module.exports = __webpack_public_path__ + "img/bg-sign.bdca52a2.png";